import { Component } from '@angular/core';
import { FormBuilder, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';
import { ExcelService } from 'src/app/core/services/excel.service';
import { ImportUsuariosService , ImportResponse } from 'src/app/core/services/import-usuarios.service';
import Swal from 'sweetalert2';

/**
 * Validadores reutilizables para archivos Excel (.xls / .xlsx)
 */
function fileRequired(control: AbstractControl): ValidationErrors | null {
  const file = control.value;
  return file instanceof File ? null : { required: true };
}

function fileExtension(allowed: string[]) {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value;
    if (!file || !(file instanceof File)) return null;
    const ok = allowed.some(ext => file.name.toLowerCase().endsWith(ext));
    return ok ? null : { extension: true };
  };
}

function maxSize(maxBytes: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value;
    if (!file || !(file instanceof File)) return null;
    return file.size <= maxBytes ? null : { maxSize: true };
  };
}

// error-detail.interface.ts
export interface ErrorDetail {
  row: number;
  field: string;
  message: string;
}

// response-data.interface.ts
export interface ResponseData {
  processed: number;
  inserted: number;
  updated: number;
  skipped: number;
  errorsCount: number;
  errors: ErrorDetail[];
}

@Component({
  selector: 'app-import-users',
  templateUrl: './import-users.component.html',
})
export class ImportUsersComponent {
  form: FormGroup;
  uploading = false;
  result?: ImportResponse;

  constructor(
    private fb: FormBuilder,
    private usuariosService: ImportUsuariosService , 
    private excelService: ExcelService
  ) {
    // inicialización del formulario reactivo
    this.form = this.fb.group({
      file: [null, [
        fileRequired,
        fileExtension(['.xls', '.xlsx']),
        maxSize(10 * 1024 * 1024), // 10 MB
      ]]
    });
  }

  /** Maneja el cambio del input file */
  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0] ? input.files[0] : null;
    this.form.patchValue({ file });
    this.form.get('file')!.markAsDirty();
    this.form.updateValueAndValidity();
  }

  /** Envía el archivo Excel al backend */
  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const file = this.form.value.file as File;
    this.uploading = true;
    this.result = undefined;


    this.usuariosService.importarUsuariosExcel(file).subscribe({
      next: (res) => {
        this.result = res;

        this.manejarRespuestaYExportar(  this.result );


        Swal.fire({
          title: 'Procesado con éxito',
          html: ``,
          icon: 'success',
          confirmButtonText: 'Ok'
        });
        
        this.uploading = false;
        this.form.reset();
      },
      error: (err) => {
        this.uploading = false;
      },
    });
  }

  manejarRespuestaYExportar(result:any ): void {
    if (result.errorsCount > 0) {
      this.excelService.exportErrorsToExcel(
        this.result, 
        'Reporte_Carga_Masiva'
      );
    }
  }

  get f() { return this.form.controls; }
}